/* eslint-disable import/no-anonymous-default-export */
import { Modal } from "antd";
import axios from "axios";
import i18next from "i18next";

let isErrorOpen = false;

const TOKEN_ERROR_TITLES = ["No Access", "Invalid token", "Token expired"];

const parseBody = (data) => {
  if (typeof data !== "string") return data;
  const trimmed = data.trim();
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) return data;
  try {
    return JSON.parse(trimmed);
  } catch (e) {
    return data;
  }
};

export const getResponseMessage = (payload, fallback = null) => {
  const response =
    payload && payload.response && typeof payload.response === "object"
      ? payload.response
      : payload;
  const body = parseBody(response && response.data);

  if (typeof body === "string") return body || fallback;
  if (!body || typeof body !== "object") {
    if (response && typeof response.message === "string" && response.message) {
      return response.message;
    }
    return fallback;
  }

  const desc =
    body.desc && typeof body.desc === "object"
      ? body.desc.message || body.desc.description
      : body.desc;
  const dataDesc =
    body.data && typeof body.data === "object"
      ? body.data.message || body.data.desc || body.data.description
      : body.data;

  return (
    body.message || body.description || desc || dataDesc || body.title || fallback
  );
};

const AUTH_ENDPOINT_PATTERNS = [
  "/users/login",
  "/users/otp",
  "/users/forgotPassword",
  "/users/register",
];

const isAuthEndpoint = (config) => {
  const url = (config && config.url) || "";
  return AUTH_ENDPOINT_PATTERNS.some((pattern) => url.includes(pattern));
};

const isTokenError = (response) => {
  const body = parseBody(response && response.data);
  if (body && typeof body === "object") {
    if (
      typeof body.title === "string" &&
      TOKEN_ERROR_TITLES.includes(body.title)
    ) {
      return true;
    }
    if (
      body.desc &&
      typeof body.desc === "object" &&
      body.desc.name === "JsonWebTokenError"
    ) {
      return true;
    }
  }
  const { status, config } = response || {};
  if (status !== 401 && status !== 403) return false;
  return !isAuthEndpoint(config);
};

const showSessionError = (store, response) => {
  i18next.init({
    lng: store.getState().changeLang.lang,
    resources: {
      en: {
        translation: {
          sessionErrorTitle: "Session error",
          sessionErrorDesc:
            "Your token already expired or invalid, Please relogin!",
        },
      },
      id: {
        translation: {
          sessionErrorTitle: "Kesalahan Sesi",
          sessionErrorDesc:
            "Token Anda sudah kadaluarsa atau tidak valid, harap login kembali!",
        },
      },
    },
  });

  if (!isErrorOpen) {
    isErrorOpen = true;

    Modal.error({
      title: i18next.t("sessionErrorTitle"),
      content: getResponseMessage(response) || i18next.t("sessionErrorDesc"),
      onOk() {
        isErrorOpen = false;
        store.dispatch({ type: "RESET_LOGIN_V2" });
      },
      afterClose() {
        isErrorOpen = false;
      },
    });
  }
  store.dispatch({ type: "LOGOUT" });
};

const showBackendError = (store, response) => {
  if (isErrorOpen) return;
  isErrorOpen = true;

  Modal.error({
    title: "Error",
    content: getResponseMessage(response) || "Terjadi kesalahan, silakan coba lagi.",
    onOk() {
      isErrorOpen = false;
      store.dispatch({ type: "RESET_LOGIN_V2" });
    },
    afterClose() {
      isErrorOpen = false;
    },
  });
};

const axiosInstance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    dataType: "json",
  },
  // withCredentials: true,
});

export const AxiosInterceptors = {
  setup: (store) => {
    axiosInstance.interceptors.response.use(
      async (response) => {
        // console.log("Response diterima:", response);
        const body = parseBody(response.data);
        if (body && body.message === "Session destroyed") {
          store.dispatch({ type: "LOGOUT" });
          return response;
        }
        if (isTokenError(response)) {
          showSessionError(store, response);
        }
        return response;
      },
      (error) => {
        console.log("callback error", error.response);
        if (error.response) {
          if (isTokenError(error.response)) {
            showSessionError(store, error.response);
            return Promise.reject(error);
          }

          if (
            error.response.status === 429 ||
            ((error.response.status === 401 ||
              error.response.status === 403) &&
              isAuthEndpoint(error.response.config))
          ) {
            showBackendError(store, error.response);
            return Promise.reject(error.response);
          }

          return Promise.reject(error.response);
        }

        if (!isErrorOpen) {
          isErrorOpen = true;

          Modal.error({
            title: "Error",
            content: error.message,
            onOk() {
              isErrorOpen = false; // reset setelah ditutup
            },
            afterClose() {
              isErrorOpen = false;
            },
          });
        }
        return Promise.reject(error);
      },
    );
  },
};
export const defaultHeader = {
  Accept: "application/json",
  "Content-Type": "application/json",
  dataType: "json",
};

export const defaultTimeout = 0;

const modif = async () => {
  const Authorization = await localStorage.getItem("Authorization");
  return Authorization;
};

const xhr = async (
  url,
  method,
  data,
  headers = defaultHeader,
  timeout = defaultTimeout,
  params,
  withCredentials = true,
  onProgress,
) => {
  headers.authorization = await modif();
  const config = {
    method,
    url,
    headers,
    data,
    params,
    timeout,
    withCredentials,
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        console.log("run... ", percent);
        onProgress(percent);
      }
    },
  };

  try {
    const res = await axiosInstance({ ...config, timeout });

    return res;
  } catch (err) {
    throw err;
  }
};

export default xhr;
